import React, { Component } from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withFirebase } from 'react-redux-firebase';
import ReactModal from 'react-modal';

import './OrganizationsContentDetailsRemoveBtn.css';

class OrganizationsContentDetailsRemoveBtn extends Component {
  constructor () {
    super();
    this.state = {
      showModal: false
    };

    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.removeOrganization = this.removeOrganization.bind(this);
  }

  handleOpenModal() {
    this.setState({ showModal: true });
  }

  handleCloseModal() {
    this.setState({ showModal: false });
  }

  async removeOrganization(e) {
    e.preventDefault();

    const { firebase, organizationId, history } = this.props;

    await Promise.all([
      firebase.remove(`organizations/${organizationId}`),
      this.handleCloseModal,
      history.push('/organizations'),
    ]);
  }

  render() {
    console.log('OrganizationsContentDetailsRemoveBtn', this.props);
    const { showModal } = this.state;

    return (
      <div className="OrganizationsContentDetailsRemoveBtn">
        <button
          className="OrganizationsContentDetailsRemoveBtn__btn"
          onClick={this.handleOpenModal}
        >
          DELETE ORGANIZATION
        </button>
        <ReactModal
          isOpen={showModal}
          contentLabel="Minimal Modal Example"
          onRequestClose={this.handleCloseModal}
          overlayClassName="OrganizationsContentDetailsRemoveBtn__overlay"
          className="OrganizationsContentDetailsRemoveBtn__modal"
        >
          <h1 className="OrganizationsContentDetailsRemoveBtn__modal__header">
            Are you sure?
          </h1>
          <div className="OrganizationsContentDetailsRemoveBtn__modal__buttons">
            <button
              onClick={this.removeOrganization}
              className={[
                'OrganizationsContentDetailsRemoveBtn__modal__buttons__button',
                'OrganizationsContentDetailsRemoveBtn__modal__buttons__button--red',
              ].join(' ')}
            >
              YES
            </button>
            <button
              onClick={this.handleCloseModal}
              className="OrganizationsContentDetailsRemoveBtn__modal__buttons__button"
            >
              NO
            </button>
          </div>
        </ReactModal>
      </div>
    );
  }
}

export default compose(
  withRouter,
  withFirebase,
  connect((_, { match }) => ({
    organizationId: match.params.organizationId,
  })),
)(OrganizationsContentDetailsRemoveBtn);



// WEBPACK FOOTER //
// ./src/components/OrganizationsContentDetailsRemoveBtn/OrganizationsContentDetailsRemoveBtn.jsx